// PendingApprovalLeave.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Paper,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";


const PendingApprovalLeave = () => {
  const [pendingLeaves, setPendingLeaves] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token") || "YOUR_FALLBACK_TOKEN";
    const config = { headers: { Authorization: `Bearer ${token}` } };

    // Fetch all leave records from the provided endpoint
    axios
      .get("https://attendanceapi.gensparc.com/leave/allleavelist", config)
      .then((response) => {
        let records = response.data;
        // Adjust if the API wraps the data in another property:
        if (!Array.isArray(records) && records.data) {
          records = records.data;
        }
        console.log("All Leave Records:", records);

        // Filter records with status "Pending" (case-insensitive)
        const pending = records.filter((record) => {
          return record.status && record.status.trim().toLowerCase() === "pending";
        });
        console.log("Pending Leave Records:", pending);
        setPendingLeaves(pending);
      })
      .catch((error) =>
        console.error("Error fetching leave records:", error)
      );
  }, []);
  const handleBackClick = () => {
    navigate("/dashboard");
  };

  return (
    <Box sx={{ padding: 0, backgroundColor: "#fafafa", minHeight: "100vh"}}>
       <Box display="flex" alignItems="center" marginBottom={3}>
        <IconButton onClick={handleBackClick} aria-label="back" sx={{marginTop:10}}>
          <ArrowBackIcon />
        </IconButton>
        <Typography
          variant="h4"
          gutterBottom
          sx={{ flexGrow: 1, textAlign: "center", marginTop:10 }}
        >
          Pending Leave Approvals
        </Typography>
        </Box>
      {pendingLeaves.length > 0 ? (
        <TableContainer component={Paper} sx={{ maxWidth: "auto", margin: "auto" }}>
          <Table>
            <TableHead sx={{ backgroundColor: "#f4f5f7" }}>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>Employee Name</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Leave Type</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Start Date</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>End Date</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Days</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {pendingLeaves.map((record) => (
                <TableRow key={record.id}>
                  <TableCell>{record.employee_name}</TableCell>
                  <TableCell>{record.leave_type}</TableCell>
                  <TableCell>
                    {record.start_date ? moment(record.start_date).format("YYYY-MM-DD") : "N/A"}
                  </TableCell>
                  <TableCell>
                    {record.end_date ? moment(record.end_date).format("YYYY-MM-DD") : "N/A"}
                  </TableCell>
                  <TableCell>{record.days || "N/A"}</TableCell>
                  <TableCell>{record.status}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Typography variant="body1" align="center">
          No pending leave approvals for today.
        </Typography>
      )}
    </Box>
  );
};

export default PendingApprovalLeave;
